import { featureFlags } from '../consts';
import { ResourceCategory } from '@core/grapql';

export const categoryToUri = (category: ResourceCategory) => {
  return `/${categoryNameToSlug(category.name)}`;
};

export const subcategoryToUri = (rootCategory: ResourceCategory, subcategory: ResourceCategory) => {
  return `/${categoryNameToSlug(rootCategory.name)}/${categoryNameToSlug(subcategory.name)}`;
};

export const categoryNameToSlug = (title: string): string => {
  const modTitle = title.toLocaleLowerCase();
  if (modTitle === 'care tech / medical products') return 'care-tech';
  if (modTitle === 'nutrition / diet') return 'nutrition';
  if (modTitle === 'physical health') return 'physical';
  if (modTitle === 'a facility') return 'facility';
  return modTitle.replace(/[^a-zA-Z0-9]/g, '-').replace(/-+/g, '-');
};

export const sortResourceCategoriesByNameFn = (a: ResourceCategory, b: ResourceCategory): number => {
  const sortOrder = [
    'assets',
    'credit cards',
    'fraud protection',
    'government benefits',
    'insurance',
    'loans',
    'services',
    'a facility',
  ];
  return sortOrder.indexOf(a.name.toLowerCase()) - sortOrder.indexOf(b.name.toLowerCase());
};

export const filterCategoriesFn = (a: ResourceCategory): boolean => {
  if (!featureFlags.facilitySubcategoryEnabled && a.name.toLocaleLowerCase() === 'a facility') return false;
  if (!featureFlags.creditCardsSubcategoryEnabled && a.name.toLocaleLowerCase() === 'credit cards') return false;
  if (!featureFlags.loansSubcategoryEnabled && a.name.toLocaleLowerCase() === 'loans') return false;
  return true;
};
